"use client";

import { IdCard, FileText, Home } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const conditions = [{
  title: "身份證明",
  description: "需具備中華民國國籍，並持有有效之國民身分證，且年滿十八歲以上之成年人。",
  icon: IdCard
}, {
  title: "醫療診斷證明",
  description: "需提供公立醫院或衛生福利部評鑑合格醫院開立之相關診斷證明書，證明文件需為三個月內開立。",
  icon: FileText
}, {
  title: "設籍與居住條件",
  description: "申請人需設籍並實際居住於本市滿六個月以上，且未接受其他同性質之相關補助。",
  icon: Home
}];
export default function SubsidyQualificationConditions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="補助資格條件" className="py-20 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 max-w-3xl" ref={ref}>
        <div className={`text-center mb-12 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight">補助資格條件</h2>
          <p className="text-muted-foreground text-lg">
            請確認您是否符合以下申請資格，以利後續作業順利進行。
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {conditions.map((condition, i) => {
          const Icon = condition.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="p-0 rounded-[8px] shadow-md border-border/40 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:shadow-primary/15 bg-card overflow-hidden group">
                  <div className="p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6">
                    <div className="shrink-0 p-4 rounded-full bg-chart-2/10 text-chart-2 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold mb-2 text-foreground">
                        {condition.title}
                      </h3>
                      <p className="text-[17px] text-muted-foreground leading-relaxed">
                        {condition.description}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}